// Assets
import "../../assets/styles/loading.css";

export default function Loading({ text = "" }) {
    return (
        <div className="loading-container">
            <div className="circle-loader" />
            {text && <p className="loading-text">{text}</p>}
        </div>
    )
} 
